import { render, staticRenderFns } from "./SelectCompanyProductBrand.vue?vue&type=template&id=99f9beda&"
import script from "./SelectCompanyProductBrand.vue?vue&type=script&lang=js&"
export * from "./SelectCompanyProductBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports